export enum CrownFireType {
  FINNEY = 1,
  SCOTT_RHEINHARDT = 0
}

export namespace CrownFireType {
  export function getOptions(): { label: string; value: CrownFireType }[] {
    return [
      { label: 'Finney (2004)', value: CrownFireType.FINNEY },
      { label: 'Scott/Reinhardt (2001)', value: CrownFireType.SCOTT_RHEINHARDT }
    ]
  }

  export function findOption(id: CrownFireType) {
    const options = CrownFireType.getOptions()
    return options.find((option) => option.value === id)
  }
}
